import bookmarksdesign from "../../assets/img/design/bookmarksdesign.webp";
import unsplash from "../../assets/img/design/unsplash.webp";
import pexels from "../../assets/img/design/pexels.webp";
import pixabay from "../../assets/img/design/pixabay.webp";
import shutterstock from "../../assets/img/design/shutterstock.webp";
import adobestock from "../../assets/img/design/adobestock.webp";
import freepik from "../../assets/img/design/freepik.webp";
import dribbble from "../../assets/img/design/dribbble.webp";
import awwwards from "../../assets/img/design/awwwards.webp";
import lapaninja from "../../assets/img/design/lapaninja.webp";
import excalidraw from "../../assets/img/design/excalidraw.webp";
import removebg from "../../assets/img/design/removebg.webp";
import svgartista from "../../assets/img/design/svgartista.webp";
import getwaves from "../../assets/img/design/getwaves.webp";
import animista from "../../assets/img/design/animista.webp";
import figma from "../../assets/img/design/figma.webp";
import sketch from "../../assets/img/design/sketch.webp";
import photopea from "../../assets/img/design/photopea.webp";
import flaticon from "../../assets/img/design/flaticon.webp";
import icons8 from "../../assets/img/design/icons8.webp";
import fontawesome from "../../assets/img/design/fontawesome.webp";
import iconicons from "../../assets/img/design/iconicons.webp";
import iconfinder from "../../assets/img/design/iconfinder.webp";
import iconmonstr from "../../assets/img/design/iconmonstr.webp";
import nounproject from "../../assets/img/design/nounproject.webp";
import iconarchive from "../../assets/img/design/iconarchive.webp";
import calcolor from "../../assets/img/design/calcolor.webp";
import colordesigner from "../../assets/img/design/colordesigner.webp";
import colorsinspo from "../../assets/img/design/colorsinspo.webp";
import coolors from "../../assets/img/design/coolors.webp";

export const DataRessources = [
	{
		title: "Bookmarks.Design",
		path: "https://www.bookmarks.design/",
		cName: "icon",
		icon: bookmarksdesign,
		description:
			"A BIG BIG Resources for design, you have most of the designs resources on this website.",
	},
];

export const DataImages = [
	{
		title: "Unsplash",
		path: "https://unsplash.com/",
		cName: "icon",
		icon: unsplash,
		description:
			"The internet’s source of freely-usable images. Powered by creators everywhere.",
	},
	{
		title: "Pexels",
		path: "https://www.pexels.com/",
		cName: "icon",
		icon: pexels,
		description:
			"The best free stock photos & videos shared by talented creators.",
	},
	{
		title: "Pixabay",
		path: "https://pixabay.com/",
		cName: "icon",
		icon: pixabay,
		description:
			"Stunning free images & royalty free stock. Over 1.8 million+ high quality stock images and videos shared by our talented community.",
	},
	{
		title: "Shutterstock",
		path: "https://www.shutterstock.com/",
		cName: "icon",
		icon: shutterstock,
		description:
			"Powering creativity. Shutterstock helps creative professionals from all backgrounds and businesses of all sizes produce their best work with incredible content and innovative tools, all on one platform.",
	},
	{
		title: "AdobeStock",
		path: "https://stock.adobe.com/",
		cName: "icon",
		icon: adobestock,
		description:
			"World-class assets. World-class creative community.",
	},
	{
		title: "Freepik",
		path: "https://www.freepik.com/",
		cName: "icon",
		icon: freepik,
		description:
			"Graphic resources for everyone. Find Free Vectors, Stock Photos, PSD and Icons",
	},
];

export const DataIcons = [
	{
		title: "Flaticon",
		path: "https://www.flaticon.com/",
		cName: "icon",
		icon: flaticon,
		description:
			"Providing you over 3 million editable vector icons. Discover our collections, patterns generator, font-face generator, and Google extensions. Iconize yourself!",
	},
	{
		title: "Icons8",
		path: "https://icons8.com/",
		cName: "icon",
		icon: icons8,
		description:
			"We have free icons, photos, interface illustrations, music for videos, and a number of cool editing tools🤘",
	},
	{
		title: "Font Awesome",
		path: "https://fontawesome.com/",
		cName: "icon",
		icon: fontawesome,
		description:
			"Get vector icons and social logos on your website with Font Awesome, the web's most popular icon set and toolkit.",
	},
	{
		title: "Icon-Icons",
		path: "https://icon-icons.com/",
		cName: "icon",
		icon: iconicons,
		description:
			"Search through more than 60.000 icons for Web & Desktop Design with advanced filter options.",
	},
	{
		title: "Iconfinder",
		path: "https://www.iconfinder.com/",
		cName: "icon",
		icon: iconfinder,
		description: "Iconfinder is a marketplace for icons",
	},
	{
		title: "Iconmonstr",
		path: "https://iconmonstr.com/",
		cName: "icon",
		icon: iconmonstr,
		description: "Free simple icons for your next project.",
	},
	{
		title: "Noun Project",
		path: "https://thenounproject.com/",
		cName: "icon",
		icon: nounproject,
		description:
			"Noun Project is building a global visual language that unites us. Mission-driven photos and icons from creators around the world.",
	},
	{
		title: "IconArchive",
		path: "https://www.iconarchive.com/",
		cName: "icon",
		icon: iconarchive,
		description:
			"Find more than 700,000 icons for web developers, end users and graphic artists here",
	},
];

export const DataInspirations = [
	{
		title: "Dribbble",
		path: "https://dribbble.com/",
		cName: "icon",
		icon: dribbble,
		description:
			"Dribbble is the leading destination to find & showcase creative work and home to the world's best design professionals.",
	},
	{
		title: "Awwwards",
		path: "https://www.awwwards.com/",
		cName: "icon",
		icon: awwwards,
		description:
			"The awards that recognize the talent and effort of the best web designers, developers and agencies in the world.",
	},
	{
		title: "Lapa Ninja",
		path: "https://www.lapa.ninja/",
		cName: "icon",
		icon: lapaninja,
		description:
			"Lapa Ninja is a gallery featuring the best 3297 landing page design inspiration, free books for designers and free UI kits from around the web",
	},
];

export const DataTools = [
	{
		title: "Excalidraw",
		path: "https://excalidraw.com/",
		cName: "icon",
		icon: excalidraw,
		description:
			"Virtual whiteboard for sketching hand-drawn like diagrams. Very useful and collaborative.",
	},
	{
		title: "Removebg",
		path: "https://www.remove.bg",
		cName: "icon",
		icon: removebg,
		description:
			"Remove image background 100% automatically and free",
	},
	{
		title: "Svg Artista",
		path: "https://svgartista.net/",
		cName: "icon",
		icon: svgartista,
		description:
			"Super handy SVG drawing animation tool, is a tool that helps you animate stroke and fill properties in your SVG images with plain CSS code.",
	},
	{
		title: "Get waves ",
		path: "https://getwaves.io/",
		cName: "icon",
		icon: getwaves,
		description:
			"A simple web tool to generate SVG breaks ",
	},
	{
		title: "Animista",
		path: "https://animista.net/",
		cName: "icon",
		icon: animista,
		description: "CSS Animations on Demand",
	},
	{
		title: "Figma",
		path: "https://www.figma.com/",
		cName: "icon",
		icon: figma,
		description:
			"Figma helps teams create, test, and ship better designs from start to finish.",
	},
	{
		title: "Sketch",
		path: "https://www.sketch.com/",
		cName: "icon",
		icon: sketch,
		description:
			"Create, prototype, collaborate, and bring your ideas to life. Only for MAC.",
	},
	{
		title: "Photopea",
		path: "https://www.photopea.com/",
		cName: "icon",
		icon: photopea,
		description:
			"Free online editor supporting PSD, XCF, Sketch, Adobe XD and CDR formats. No more Photoshop or Illustrator.",
	},
];

export const DataColors = [
	{
		title: "Calcolor",
		path: "https://calcolor.co/",
		cName: "icon",
		icon: calcolor,
		description:
			"A new way to manage digital colors. Leave abstract color models behind and focus on the important things.",
	},
	{
		title: "Colorsinspo",
		path: "https://colorsinspo.com/",
		cName: "icon",
		icon: colorsinspo,
		description:
			"Colorsinspo is all in one resource for finding everything about colors with extreme ease. Also, you will get Freebies, Inspirations, Color Tools, and Gradients.",
	},
	{
		title: "Color Designer",
		path: "https://colordesigner.io/",
		cName: "icon",
		icon: colordesigner,
		description:
			"The main purpose of this tool is to help with building a color palette and generate tints and shades based on it. Just pick a color, and the app does the rest. You can use the preselected colors or the color picker for more control.",
	},
	{
		title: "Coloors",
		path: "https://coolors.co/",
		cName: "icon",
		icon: coolors,
		description:
			"The super fast color schemes generator + a collection of more than 1,5 M palettes!",
	},
];
